export const GET_PROFILE_DATA_SUC = 'user.getProfileData.success';
export const getProfileDataSuccess = (uuid, sportId, data) => ({
  type: GET_PROFILE_DATA_SUC,
  uuid,
  sportId,
  data,
});
